// Paletas precargadas de "Lumina" (15 años).
const FUENTES = {
  display: '"Fraunces", Georgia, serif',
  cuerpo: '"Outfit", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "rosaEmpolvado",
    nombre: "Rosa empolvado",
    tema: {
      colores: {
        fondo: "#FBF6F4",
        fondoAlt: "#F6ECE8",
        texto: "#33222A",
        textoSuave: "#6B5560",
        textoTenue: "#9A8891",
        primario: "#A5536B",
        primarioSuave: "#F3E0E5",
        acento: "#B78B62",
        borde: "rgba(165, 83, 107, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "champagne",
    nombre: "Champagne",
    tema: {
      colores: {
        fondo: "#FAF7F0",
        fondoAlt: "#F3ECDF",
        texto: "#2A241C",
        textoSuave: "#615747",
        textoTenue: "#968B7A",
        primario: "#8A6D3B",
        primarioSuave: "#EFE6D2",
        acento: "#B08D4F",
        borde: "rgba(138, 109, 59, 0.18)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "lavanda",
    nombre: "Lavanda",
    tema: {
      colores: {
        fondo: "#F7F5FA",
        fondoAlt: "#EFEBF5",
        texto: "#241F2E",
        textoSuave: "#554E63",
        textoTenue: "#8D86A0",
        primario: "#6C5B9E",
        primarioSuave: "#E7E1F2",
        acento: "#B79D6B",
        borde: "rgba(108, 91, 158, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
];
